import * as React from 'react';
import { IconProps } from '../types';

const IcMenuHome = (props: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    viewBox="0 0 24 24"
    fill="none"
    {...props}
  >
    <path
      fill={props?.fill ?? '#232F3E'}
      d="m21.523 7.657-7.808-5.282a2.163 2.163 0 0 0-2.43 0L3.477 7.657a2.19 2.19 0 0 0-.722.803c-.17.324-.258.687-.255 1.055V19.97C2.5 21.111 3.57 22 4.93 22h15.14c1.36 0 2.43-.89 2.43-2.029V9.515a2.227 2.227 0 0 0-.255-1.055 2.19 2.19 0 0 0-.722-.803ZM14.039 20.44h-3.077v-4.83c0-.168.065-.328.182-.447a.619.619 0 0 1 .44-.185h1.831c.166 0 .324.067.441.185.117.119.183.28.183.447v4.83Zm6.923-.468c0 .187-.354.468-.893.468h-4.492v-4.83c0-.582-.228-1.14-.633-1.55a2.146 2.146 0 0 0-1.529-.643h-1.83c-.574 0-1.123.231-1.529.643a2.209 2.209 0 0 0-.633 1.55v4.83H4.931c-.539 0-.892-.28-.892-.468V9.515a.64.64 0 0 1 .292-.547l7.808-5.298a.655.655 0 0 1 .723 0l7.815 5.29a.645.645 0 0 1 .285.555V19.97Z"
    />
  </svg>
);

export default IcMenuHome;
